import { Dialog } from '@leverege/ui-elements'
import PropTypes from 'prop-types'
import React from 'react'

const { PathEditor } = require( './PathEditor' )

class PathsModal extends React.Component {
  static propTypes = {
    onPath : PropTypes.func.isRequired,
    paths : PropTypes.arrayOf( PropTypes.oneOfType( [ PropTypes.array, PropTypes.string ] ) ),
    isOpen : PropTypes.bool,
    close : PropTypes.func,
    newPath : PropTypes.oneOfType( [ PropTypes.array, PropTypes.string ] ).isRequired,
    pathSuggestions : PropTypes.array
  }

  static defaultProps = {
    isOpen : false,
    paths : null,
    close : () => {},
    pathSuggestions : []
  }

  render() {
    const { paths, pathSuggestions, newPath, onPath, isOpen, close } = this.props

    const pathComponents = (
      paths && paths.map( ( path, index ) => {
        return <PathEditor pathSuggestions={pathSuggestions} key={typeof path === 'string' ? `${path}-${index}` : `${path[0]}-${index}`} path={path} index={index} onChange={onPath} />
      } )
    ) || []

    pathComponents.push( <PathEditor pathSuggestions={pathSuggestions} path={newPath} key="newPath" index={-1} onChange={onPath} create /> )

    return (
      <Dialog.Message
        show={isOpen}
        onClose={close}
        title="Add and Remove Paths">
        {pathComponents}
      </Dialog.Message>
    )
  }
}

exports.PathsModal = PathsModal
